import { defineMessages, useIntl } from 'react-intl'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import Group from 'components/utils/Group'

const messages = defineMessages({
  title: {
    id: '5YPiLJ5lPiyrkn9veV0P',
    defaultMessage: 'Callback request error',
    description: 'Heading title for callback request error modal in a modal dialog',
  },
  message: {
    id: 'H2nTs2afRH_vHTJSpL4F',
    defaultMessage: 'There was an error scheduling your callback.',
    description: 'Error message when callback scheduling fails when an issue occurs',
  },
  closeButton: {
    id: 'xhDcfqBWlYOXTAaJNUTX',
    defaultMessage: 'Close',
    description: 'Close/dismiss button for callback error modal in a modal dialog',
  },
})

interface ContentProps {
  showTitle?: boolean
}

export function RequestAgentCallbackErrorContent(props: ContentProps) {
  const intl = useIntl()

  return (
    <VerticalSpacer gap={20}>
      {props.showTitle && (
        <Heading as="h2" variant="heading3">
          {intl.formatMessage(messages.title)}
        </Heading>
      )}
      <Group direction="vertical" gap={20}>
        <BodyTextBlock variant="large">
          {intl.formatMessage(messages.message)}
        </BodyTextBlock>
      </Group>
    </VerticalSpacer>
  )
}

export function RequestAgentCallbackErrorModal() {
  const intl = useIntl()

  return (
    <ModalBase>
      <form>
        <ModalHeader title={intl.formatMessage(messages.title)} />
        <ModalBody>
          <ModalContent>
            <RequestAgentCallbackErrorContent />
          </ModalContent>
        </ModalBody>
        <ModalFooter
          primaryActionProps={{
            children: intl.formatMessage(messages.closeButton),
          }}
        />
      </form>
    </ModalBase>
  )
}
